// Input
export const DEFAULT_WITH: number = 200;

// Pagination
export const DOTS: string = '...';
export const INITIAL_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

// Regex Patterns
export const INPUT_DATE_PATTERN = /(\d{2})\/(\d{2})\/(\d{4})/;
